import { Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../../theme/ThemeProvider';

/**
 * A bay someone else is charging on.
 *
 * The picker already refuses to open one of these, but the screen is also
 * reachable by its own address — a shared link, a bookmark, the back button —
 * and the charging branch had no notion of whose charge it was rendering. A
 * stranger got the live view and a Stop button, and the only thing standing
 * between them and stopping it was the backend's 403, whose refusal then
 * appeared in red beneath the button.
 */
export const ConnectorInUse = ({ connectorId }: { connectorId: number }) => {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      sx={{
        mt: 4,
        width: '100%',
        gap: '12px',
        padding: '24px 16px',
        borderRadius: '15px',
        border: `1px solid ${theme.palette.gray[50]}`,
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
      }}
    >
      <LockOutlinedIcon sx={{ fontSize: 32, color: theme.palette.gray[50] }} />
      <Typography variant="h2" color="common.white" textAlign="center">
        {t('orderPage.connectorInUse.title', { connectorId })}
      </Typography>
      <Typography
        variant="body2"
        // gray.100 rather than the gray.50 used for muted text: this sits on a
        // lightened surface where gray.50 falls under AA at this size.
        color="gray.100"
        textAlign="center"
        sx={{ lineHeight: 1.45 }}
      >
        {t('orderPage.connectorInUse.hint')}
      </Typography>
    </Stack>
  );
};
